import * as api from '../api'

export const getResearcherBibliometrics = async(crisId) => {
    return api.get(`/researcher/${crisId}/bibliometrics`, null)
}